export default {
  pay: "Zahlen",
  acceptTermsAndConditions: "Nutzungsbedingungen akzeptieren",
  selectYourCard: "WÄHLEN SIE IHRE KARTE",
  yourOrder: "DEINE BESTELLUNG",
  generalPlaceHolderNotes:
    "Sie können Zutaten entfernen, Sie können sie nicht hinzufügen oder ändern",
  placeholderNotesDrinks: "Bemerkungen ...",
  placeholderNotesFood: "Bemerkungen ...",
  total: "GESAMT:",
  totalToPay: "Gesamtbetrag:",
  paymentConfirmation: "Zahlungsbestätigung",
  paymentRequest: "Sie haben die Zahlung von:",
  payCash: "Bar bezahlen",
  yourOrderIsInProgress: "Ihre Bestellung ist in Bearbeitung,",
  itWillReachYou: "es wird dich erreichen",
  desk: "Schreibtisch",
  paymentMethod: "BEZAHLVERFAHREN",
  dataphone: "Datentelefon",
  smartphone: "Smartphone",
  howDoYouWantToPay: "Wie möchten Sie zahlen?",
  creditOrDebitCard: "Kredit- oder Debitkarte",
  missingPay: "Fehlende Bezahlung:",
  petitionRejected: "Petition abgelehnt",
  redirectingToThePaymentprocess: "Weiterleitung zum Bezahlvorgang",
  addNewCard: "Neue Karte hinzufügen",
  paymentMade: "Zahlung erfolgt",
  receiptOfYourPaymentTo: "Eingang Ihrer Zahlung an"
};
